import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import ServiceCategoryNavbar from "./ServiceCategoryNavbar";
import { useNavigate } from "react-router-dom";


const AllServiceCategory = () => {
  const [categories, setCategories] = useState([]);
  const [whatWeDoId, setWhatWeDoId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subcategoryId, setSubcategoryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");
const [subSubcategoryId, setSubSubcategoryId] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${baseurl}getAllServiceCategories`)
      .then((res) => {
        setCategories(res.data.data || []);
      })
      .catch((err) => {
        console.error("Fetch categories error:", err);
      });
  }, []);

  const getParentName = (id) => {
    const parent = categories.find((cat) => cat.id === id);
    return parent ? parent.service_title : "-";
  };

  const filterByHierarchy = () => {
    if (cityId) {
  return categories.filter((cat) => cat.parent_id === parseInt(cityId));
} else if (stateId) {
  return categories.filter((cat) => cat.parent_id === parseInt(stateId));
} else if (subSubcategoryId) {
  return categories.filter((cat) => cat.parent_id === parseInt(subSubcategoryId));
}
else if (subcategoryId) {
      return categories.filter((cat) => cat.parent_id === parseInt(subcategoryId));
    } else if (categoryId) {
      return categories.filter((cat) => cat.parent_id === parseInt(categoryId));
    } else if (whatWeDoId) {
      return categories.filter((cat) => cat.parent_id === parseInt(whatWeDoId));
    } else {
      return categories.filter((cat) => cat.parent_id === null); // What We Do
    }
  };

  const whatWeDoList = categories.filter((cat) => cat.parent_id === null);
  const categoryList = categories.filter((cat) => cat.parent_id === parseInt(whatWeDoId));
  const subcategoryList = categories.filter((cat) => cat.parent_id === parseInt(categoryId));
  const stateList = categories.filter((cat) => cat.parent_id === parseInt(subcategoryId));
  const cityList = categories.filter((cat) => cat.parent_id === parseInt(stateId));
const subSubcategoryList = categories.filter((cat) => cat.parent_id === parseInt(subcategoryId));





  const handleEdit = (category) => {
  // You can navigate to edit page or open a modal
  console.log("Editing:", category);
  navigate(`/admin/edit-service-category/${category}`);
  // Example: navigate(`/admin/edit-service-category/${category.id}`);
};

const handleDelete = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This category will be deleted permanently.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .delete(`${baseurl}deleteServiceCategoryById/${id}`)
        .then((res) => {
          Swal.fire("Deleted!", "The category has been deleted.", "success");
          setCategories(categories.filter((cat) => cat.id !== id));
        })
        .catch((err) => {
          console.error("Delete error:", err);
          Swal.fire("Error", "Something went wrong while deleting.", "error");
        });
    }
  });
};




  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <ServiceCategoryNavbar />

          <div className="crd1 mb-4">
            <h4 className="mb-3">Service Category Filter</h4>
            <div className="row g-3">
              {/* What We Do */}
              <div className="col-md-2">
                <label>What We Do</label>
                <select
                  className="form-select"
                  value={whatWeDoId}
                  onChange={(e) => {
                    setWhatWeDoId(e.target.value);
                    setCategoryId("");
                    setSubcategoryId("");
                    setStateId("");
                    setCityId("");
                  }}
                >
                  <option value="">-- Select --</option>
                  {whatWeDoList.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.service_title}
                    </option>
                  ))}
                </select>
              </div>

              {/* Category */}
              <div className="col-md-2">
                <label>Category</label>
                <select
                  className="form-select"
                  value={categoryId}
                  onChange={(e) => {
                    setCategoryId(e.target.value);
                    setSubcategoryId("");
                    setStateId("");
                    setCityId("");
                  }}
                  disabled={!whatWeDoId}
                >
                  <option value="">-- Select --</option>
                  {categoryList.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.service_title}
                    </option>
                  ))}
                </select>
              </div>

              {/* Subcategory */}
              <div className="col-md-2">
                <label>Subcategory</label>
                <select
                  className="form-select"
                  value={subcategoryId}
                  onChange={(e) => {
                    setSubcategoryId(e.target.value);
                    setStateId("");
                    setCityId("");
                  }}
                  disabled={!categoryId}
                >
                  <option value="">-- Select --</option>
                  {subcategoryList.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.service_title}
                    </option>
                  ))}
                </select>
              </div>


{/* Sub-Subcategory */}
<div className="col-md-3">
  <label>Sub-Subcategory</label>
  <select
    className="form-select"
    value={subSubcategoryId}
    onChange={(e) => {
      setSubSubcategoryId(e.target.value);
      setStateId("");
      setCityId("");
    }}
    disabled={!subcategoryId}
  >
    <option value="">-- Select --</option>
    {subSubcategoryList.map((cat) => (
      <option key={cat.id} value={cat.id}>
        {cat.service_title}
      </option>
    ))}
  </select>
</div>



              {/* State */}
              <div className="col-md-3">
                <label>State</label>
                <select
                  className="form-select"
                  value={stateId}
                  onChange={(e) => {
                    setStateId(e.target.value);
                    setCityId("");
                  }}
                  disabled={!subcategoryId}
                >
                  <option value="">-- Select --</option>
                  {stateList.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.service_title}
                    </option>
                  ))}
                </select>
              </div>

              {/* City */}
              {/* <div className="col-md-3">
                <label>City</label>
                <select
                  className="form-select"
                  value={cityId}
                  onChange={(e) => setCityId(e.target.value)}
                  disabled={!stateId}
                >
                  <option value="">-- Select --</option>
                  {cityList.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.service_title}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </div>

          {/* Filtered Table */}
          <div className="card">
            <div className="card-body">
              <h5>Filtered Categories</h5>
              <div className="table-responsive">
                <table className="custom-table">
  <thead className=" ">
    <tr>
      <th>#</th>
      <th>Category Name</th>
      <th>Parent</th>
      <th>Slug</th>
      <th>Has Service</th>
      <th>Action</th> {/* New Action column */}
    </tr>
  </thead>
  <tbody>
    {filterByHierarchy().sort((a, b) => a.service_title.localeCompare(b.service_title)).map((cat, index) => (
      <tr key={cat.id}>
        <td>{index + 1}</td>
        <td>{cat.service_title}</td>
        <td>{getParentName(cat.parent_id)}</td>
        <td>{cat.slug}</td>
        <td>{cat.has_service ? "Yes" : "No"}</td>
        <td>
          <button
            className="btn btn-sm btn-info me-2"
            onClick={() => handleEdit(cat.id)}
          >
            Edit
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(cat.id)}
          >
            Delete
          </button>
        </td>
      </tr>
    ))}
    {filterByHierarchy().length === 0 && (
      <tr>
        <td colSpan="6" className="text-center">
          No categories found.
        </td>
      </tr>
    )}
  </tbody>
</table>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AllServiceCategory;
